export const industriesData = [
  {
    category: "Building, Construction and Maintenance",
    subcategories: [
      {
        name: "Building Maintenance",
        items: [
          "Carpentry",
          "Electrical Services",
          "Fabricators",
          "Facility Management",
          "Fire Protection",
          "Flooring Contractors",
          "Handyman Services",
          "Interior Design & Architecture",
          "Landscaping",
          "Locksmith",
          "Maid Services",
          "Manpower Security",
          "Manpower Supply",
          "Mechanical Services",
          "Painting",
          "Pest Control",
          "Plumbing",
        ],
      },
      {
        name: "Commercial Real Estate",
        items: [
          "Commercial Land",
          "Industrial Land",
          "Office Space",
          "Rented Commercial Properties",
          "Shopping Malls",
          "Showrooms",
          "Warehouse Property",
        ],
      },
      {
        name: "Construction Materials",
        items: [
          "Asphalt Manufacturing",
          "Brick Factories",
          "Cement Factories",
          "Construction Material Processing",
          "Construction Material Wholesale",
          "Granite & Marble",
          "Hard Mineral Mining",
          "Iron & Steel Stores",
          "Refractory Materials",
          "Scaffolding",
          "Tile Stores",
        ],
      },
      {
        name: "Construction Supplies",
        items: [
          "Bathroom Fixtures",
          "Construction Supplies Wholesale",
          "Door Fixtures",
          "Kitchen Cabinets",
          "Luxury Construction Supplies",
          "Plumbing Fittings",
          "Roofing Supplies",
          "Tiles Manufacturing",
          "UPVC Windows",
        ],
      },
      {
        name: "Engineering, Procurement & Construction",
        items: [
          "Building Contractors",
          "Electric Construction",
          "Gas Construction",
          "Industrial Automation",
          "Industrial Design",
          "Industrial Plant Construction",
          "MEP Construction",
          "Railway Construction",
          "Road Construction",
          "Smart Grid Construction",
          "Telecommunication Construction",
          "Water Construction",
        ],
      },
      {
        name: "Home Furnishings",
        items: [
          "Antiques",
          "Blinds Manufacturing",
          "Cutlery and Flatware",
          "Furniture",
          "Home Furnishings Wholesale",
          "Kitchen Utensils",
          "Luxury Furnishing",
          "Solid Surface",
          "Tools and Housewares",
          "Wallpaper",
        ],
      },
      {
        name: "Household Products",
        items: [
          "Air Fresheners",
          "Auto Cleaning Products",
          "Brooms, Brushes and Dustpans",
          "Cleaning Supplies",
          "Laundry Supplies",
          "Paper Tissue",
        ],
      },
    ],
  },
  {
    category: "Business Services",
    subcategories: [
      {
        name: "BPO's & Outsourcing",
        items: [
          "BPOs",
          "Back Office Outsourcing",
          "Call Centers",
          "eGovernance",
        ],
      },
      {
        name: "Employment & Staffing Services",
        items: [
          "Employment Services",
          "Background Verification",
          "HR Consulting",
          "Recruitment Agencies",
          "Staffing",
        ],
      },
      {
        name: "IT Services & Consultancy",
        items: [
          "IT Services",
          "Custom Application Development",
          "Digital Technology Services",
          "IT Consultancy",
          "IT Infrastructure",
          "Outsourced Product Development",
          "Software Testing Services",
          "Web & Mobile Development",
        ],
      },
      {
        name: "Professional Services",
        items: [
          "Professional Services",
          "Accounting Firms",
          "Business Research",
          "Consulting",
          "Document Management",
          "Image Editing Services",
          "Immigration Consulting",
          "Law Firms",
          "Technical Documentation",
          "Testing, Inspection & Certification",
          "Translation and Interpretation",
        ],
      },
    ],
  },
  {
    category: "Education",
    subcategories: [
      {
        name: "Education Support",
        items: [
          "Book Shops",
          "Education Consultants",
          "Libraries",
          "Stationery Stores",
        ],
      },
      {
        name: "Schools & Colleges",
        items: ["Colleges", "Playschools", "Schools"],
      },
      {
        name: "Training Institutes",
        items: [
          "Animation",
          "Beauty Schools",
          "Coaching Centers",
          "Computer Training",
          "Dance Studios",
          "Fashion Institutes",
          "Hobby Classes",
          "Language Centers",
          "Paint & Sip",
          "Sports Coaching",
        ],
      },
    ],
  },
  {
    "category": "Energy",
    "subcategories": [
      {
        "name": "Coal",
        "items": [
          "Coal",
          "Charcoal",
          "Coal Mining Support",
          "Coal Wholesale"
        ]
      },
      {
        "name": "Environmental Services",
        "items": [
          "Air Purification",
          "Carbon Storage",
          "Environmental Biotechnology",
          "Environmental Consultancy",
          "Soil Purification",
          "Solar Projects",
          "Waste Management",
          "Waste to Energy Service"
        ]
      },
      {
        "name": "Integrated Oil and Gas",
        "items": [
            "Integrated Oil and Gas"
        ]
      },
      {
        "name": "Multiline Utilities",
        "items": [
            "Multiline Utilities"
        ]
      },
      {
        "name": "Natural Gas Utilities",
        "items": [
          "Gas Distribution"
        ]
      },
      {
        "name": "Nonrenewable Power Plants",
        "items": [
            "Nonrenewable Power Plants"
        ]
      },
      {
        "name": "Oil & Gas Drilling",
        "items": [
          "Offshore Oil Drilling"
        ]
      },
      {
        "name": "Oil & Gas Exploration and Production",
        "items": [
          "Offshore Gas Production",
          "Offshore Oil Production",
          "Onshore Gas Production",
          "Onshore Oil Production",
          "Unconventional Oil & Gas Production"
        ]
      },
      {
        "name": "Oil & Gas Refining and Marketing",
        "items": [
          "LPG Gas Agencies",
          "Petrol Bunks",
          "Petroleum Product",
          "Petroleum"
        ]
      },
      {
        "name": "Oil & Gas Transportation",
        "items": [
          "Gas Pipeline",
          "LNG Transportation",
          "Oil Pipeline",
          "Oil & Gas Storage"
        ]
      },
      {
        "name": "Oil",
        "items": [
          "Oil Equipment",
          "Oil Services",
          "Oil Surveying and Mapping"
        ]
      },
      {
        "name": "Renewable Energy Equipment",
        "items": [
          "Biomass Energy Equipment",
          "Geothermal Equipment",
          "Hydropower Equipment"
        ]
      },
      {
        "name": "Renewable Energy",
        "items": [
          "Solar PV Systems",
          "Solar Products",
          "Thermal Solar Equipment",
          "Wind Energy Equipment"
        ]
      },
      {
        "name": "Renewable Fuels",
        "items": [
          "Biodiesel",
          "Biomass Fuels",
          "Ethanol Fuels",
          "Hydrogen Fuel",
          "Synthetic Fuels"
        ]
      },
      {
        "name": "Renewable Power Plants",
        "items": [
          "Biomass Power Plants",
          "Hydropower Plants",
          "Solar Power Plants",
          "Wind Mills"
        ]
      },
      {
        "name": "Water Utilities",
        "items": [
          "Irrigation",
          "Steam Supply",
          "Water Purifiers",
          "Water Treatment"
        ]
      }
    ]
  },
  {
    "category": "Finance",
    "subcategories": [
      {
        "name": "Banks",
        "items": [
          "ATMs",
          "Private Banks"
        ]
      },
      {
        "name": "Consumer Lending",
        "items": [
          "Consumer Leasing",
          "Microfinance",
          "NBFC",
          "Pawn Shops",
          "Personal Loans"
        ]
      },
      {
        "name": "Corporate Financial Services",
        "items": [
          "Commercial Leasing",
          "Commercial Loans",
          "Factoring",
          "Import/Export Banks",
          "International Trade Finance"
        ]
      },
      {
        "name": "Financial Distributors",
        "items": [
          "Debt Collection Agencies",
          "Insurance Agencies",
          "Mutual Fund Agents",
          "Payment Services",
          "Stock Advisory"
        ]
      },
      {
        "name": "Financial Market Operators",
        "items": [
          "Stock Broking"
        ]
      },
      {
        "name": "Fund Operators",
        "items": [
          "Asset Management",
          "Hedge Funds",
          "Private Equity",
          "Venture Capital",
          "Wealth Management"
        ]
      },
      {
        "name": "Investment Banks",
        "items": [
          "M&A Advisory"
        ]
      },
      {
        "name": "Life & Health Insurance",
        "items": [
          "Health Insurance",
          "Life Insurance"
        ]
      },
      {
        "name": "Property & Casualty Insurance",
        "items": [
          "Auto Insurance",
          "Casualty Insurance",
          "Travel Insurance"
        ]
      },
      {
        "name": "Shell Companies",
        "items": [
          "Holding Companies",
          "Nonprofit Organisations"
        ]
      }
    ]
  },
  {
    "category": "Food & Beverage",
    "subcategories": [
      {
        "name": "Agriculture",
        "items": [
          "Agriculture Consulting",
          "Agriculture Support",
          "Agriculture Wholesale",
          "Animal Breeding",
          "Animal Feed",
          "Aquaculture",
          "Coffee Estates",
          "Commercial Nurseries",
          "Dairy Farms",
          "Fishing",
          "Grain Farms",
          "Orchards",
          "Organic Farming",
          "Poultry",
          "Ranches",
          "Sugarcane Farms",
          "Vegetable Farms"
        ]
      },
      {
        "name": "Alcoholic Beverages",
        "items": [
          "Breweries",
          "Distilleries",
          "Malt Producers",
          "Wineries"
        ]
      },
      {
        "name": "Food Processing",
        "items": [
          "Baby Food",
          "Bakery Products",
          "Biscuit Manufacturing",
          "Breakfast Cereal Manufacturing",
          "Chocolate and Confectionery",
          "Coffee and Tea",
          "Dairy Products",
          "Edible Oil",
          "Flour Mills",
          "Food Ingredients",
          "Frozen Food",
          "Halal Slaughterhouses",
          "Honey Processing",
          "Hummus Manufacturing",
          "Nutrition Food",
          "Pet Food",
          "Plant-based Protein Manufacturers",
          "Ready-Made Meals",
          "Rice Mills",
          "Seafood Processing",
          "Slaughterhouses",
          "Snack Manufacturing",
          "Spices",
          "Sugar Factories",
          "Vegetable Processing"
        ]
      },
      {
        "name": "Non-Alcoholic Beverages",
        "items": [
          "Bottled Water",
          "Energy Drinks",
          "Fruit Drinks",
          "Ice Factories",
          "Soft Drinks"
        ]
      },
      {
        "name": "Restaurants and Bars",
        "items": [
          "Bakeries",
          "Bars",
          "Cafes",
          "Catering",
          "Cloud Kitchens",
          "Delicatessens",
          "Fast Food Restaurants",
          "Food Carts",
          "Food Delivery",
          "Ice Cream Parlors",
          "Juice & Snack Shops",
          "Nightclubs",
          "Restaurants",
          "Shisha Cafes",
          "Sweet Shops",
          "Take Aways",
          "Waffle Stores"
        ]
      },
      {
        "name": "Tobacco",
        "items": [
          "Chewing Tobacco Products",
          "Cigarettes",
          "Tobacco Farms",
          "Tobacco Stemming and Redrying"
        ]
      }
    ]
  },
  {
    "category": "Healthcare",
    "subcategories": [
      {
        "name": "Advanced Medical Technology",
        "items": [
          "Advanced Medical Equipment Wholesale",
          "Medical Imaging Systems",
          "Medical Monitoring Systems",
          "Medical Testing Equipment"
        ]
      },
      {
        "name": "Beauty and Wellness",
        "items": [
          "Beauty Clinics",
          "Beauty Product Shops",
          "Beauty Salons",
          "Cosmetics",
          "Gyms",
          "Hair Accessories",
          "Hygiene Products",
          "Nail Salon",
          "Perfumes",
          "Spas",
          "Tanning Salons",
          "Tattoo Studios",
          "Yoga Studios"
        ]
      },
      {
        "name": "Biotechnology",
        "items": [
          "Bio Diagnostics",
          "Bio Medical Devices",
          "Bio Therapeutic Drugs"
        ]
      },
      {
        "name": "Healthcare Services",
        "items": [
          "Alternative Medicine Facilities",
          "Ambulance",
          "Clinics",
          "Dentist Clinics",
          "Diagnostic Labs",
          "Fertility Centres",
          "Home Healthcare",
          "Hospitals",
          "Medical Tourism",
          "Nursing Homes",
          "Physiotherapy Practices",
          "Psychiatric Clinics",
          "Telemedicine",
          "Veterinary Clinics"
        ]
      },
      {
        "name": "Medical Supplies and Equipment",
        "items": [
          "Diagnostic Substances",
          "Drug Delivery Systems",
          "Eye Glasses Manufacturing",
          "Medical Devices",
          "Medical Equipment Wholesale",
          "Medical Implants",
          "Medical Prosthetics",
          "Medical Supplies",
          "Veterinary Medical Supplies"
        ]
      },
      {
        "name": "Pharmaceuticals",
        "items": [
          "Alternative Medicine",
          "Biopharmaceuticals",
          "Diagnostic Substances Manufacturing",
          "Generic Pharmaceuticals",
          "Nutraceuticals",
          "Pharma Marketing",
          "Specialty Pharmaceuticals",
          "Veterinary Drugs"
        ]
      }
    ]
  },  
  {
    "category": "Industrial",
    "subcategories": [
      {
        "name": "Aerospace & Defense",
        "items": [
          "Aircraft Equipment Wholesale",
          "Arms and Ammunitions",
          "Commercial Aircraft Manufacturing",
          "Military Accessories",
          "Spacecraft Manufacturing"
        ]
      },
      {
        "name": "Agricultural Chemicals",
        "items": [
          "Agricultural Chemicals Wholesale",
          "Fertilizer",
          "Pesticide",
          "Seaweed Products"
        ]
      },
      {
        "name": "Aluminium",
        "items": [
          "Aluminium Rolling",
          "Aluminium Smelting",
          "Aluminium Wholesalers"
        ]
      },
      {
        "name": "Auto Component",
        "items": [
          "Auto Electrical Parts",
          "Automobile Parts Wholesale",
          "Automotive Accessories",
          "Automotive Body Parts",
          "Automotive Systems",
          "Engine and Powertrain Systems",
          "Motorcycle Parts"
        ]
      },
      {
        "name": "Automobile Manufacturing",
        "items": [
          "Automobile Wholesale",
          "Bicycle Manufacturing",
          "Car Manufacturing",
          "Electrical Vehicles",
          "Light Trucks",
          "Luxury Vehicles",
          "Marine Equipment",
          "Motorcycles and Scooters",
          "Yachts and Boats"
        ]
      },
      {
        "name": "Commodity Chemicals",
        "items": [
          "Carbon Black Manufacturing",
          "Coating",
          "Commodity Chemicals Wholesale",
          "Explosives Manufacturing",
          "Industrial Gas",
          "Ink Manufacturers",
          "Paint Factories",
          "Petrochemicals",
          "Plastics",
          "Vinyl"
        ]
      },
      {
        "name": "Diversified Chemicals",
        "items": [
            "Diversified Chemicals"
        ]
      },
      {
        "name": "Electrical Equipment",
        "items": [
          "Battery and UPS Manufacturing",
          "Electric Equipment Wholesale",
          "Electrical Component",
          "Electrical Measuring Instruments",
          "Electron Tubes and Insulators",
          "HVAC Equipment",
          "Lighting Fixtures",
          "Portable Motors and Generators",
          "Switchgear",
          "Wires and Cables"
        ]
      },
      {
        "name": "Forest Products",
        "items": [
          "Jute & Coir",
          "Sawmills",
          "Timber Tract Operations",
          "Timber Trading",
          "Tree Farms",
          "Wood Products"
        ]
      },
      {
        "name": "Gold",
        "items": [
          "Gold Mining"
        ]
      },
      {
        "name": "Heavy Electrical Equipment",
        "items": [
          "Conveyor",
          "Elevator",
          "Heavy Motors and Generators",
          "Industrial Electrical Switchgear",
          "Smart Grid Equipment",
          "Transformer Manufacturing",
          "Turbine Manufacturing"
        ]
      },
      {
        "name": "Heavy Machinery",
        "items": [
          "Agricultural Machinery",
          "Cleaning Machinery",
          "Construction Machinery",
          "Heavy Machinery Wholesale",
          "Heavy Trucks",
          "Locomotive Manufacturing"
        ]
      },
      {
        "name": "Industrial Machinery",
        "items": [
          "Air Compressors",
          "Fluid Power Products",
          "Furnace Manufacturing",
          "Industrial Filters",
          "Industrial Machinery Wholesale",
          "Industrial Measuring Equipment",
          "Machine Tools",
          "Pipes & Valves",
          "Pumps",
          "Rebar Coupler",
          "Rolling Mill Machinery",
          "Vending Machine Manufacturing",
          "Welding Equipment"
        ]
      },
      {
        "name": "Machine Shops",
        "items": [
          "Ball Bearings",
          "Die Casting",
          "Electroplating",
          "Fabricated Metal Products",
          "Industrial Moulds",
          "Injection Moulding",
          "Metal Service Centers",
          "Powder Coating Plants",
          "Precision Components",
          "Rolling Mills"
        ]
      },
      {
        "name": "Mining Support",
        "items": [
          "Geophysical Service",
          "Mining Machinery"
        ]
      },
      {
        "name": "Packaging",
        "items": [
          "Glass",
          "Metal Container",
          "Packaging Material Wholesale",
          "Paper Packaging",
          "Plastic Packaging",
          "Textile Packaging",
          "Wood Packaging"
        ]
      },
      {
        "name": "Precious Metals",
        "items": [
          "Diamond Mining",
          "Jade",
          "Rare Earth Minerals",
          "Semiprecious Gem Stones"
        ]
      },
      {
        "name": "Pulp & Paper",
        "items": [
          "Paper Mills",
          "Pulp & Paper Wholesale"
        ]
      },
      {
        "name": "Scrap Metal",
        "items": [
            "Scrap Metal"
        ]
      },
      {
        "name": "Shipbuilding",
        "items": [
          "Ship Parts",
          "Ship Repairing"
        ]
      },
      {
        "name": "Specialty Chemicals",
        "items": [
          "Adhesive",
          "Advanced Polymer",
          "Cellular Fiber",
          "Coloring Agent",
          "Epoxy Resins",
          "Industrial Biotechnology Chemicals",
          "Specialty Chemicals Wholesale"
        ]
      },
      {
        "name": "Specialty Mining",
        "items": [
          "Copper Ore Mining",
          "Nickel Ore Mining",
          "Nonferrous Metal Mining",
          "Nonferrous Metal",
          "Specialty Metal Wholesale"
        ]
      },
      {
        "name": "Steel",
        "items": [
          "Coke Coal Mining",
          "Foundries",
          "Iron Ore Mining"
        ]
      },
      {
        "name": "Tires and Rubber Products",
        "items": [
          "Industrial Rubber",
          "Natural Rubber",
          "Rubber Product Wholesale",
          "Tire Manufacturing",
          "Tire Retreading"
        ]
      },
      {
        "name": "Trading",
        "items": [
          "Import / Export"
        ]
      }
    ]
  },  
  {
    "category": "Logistics",
    "subcategories": [
      {
        "name": "Airlines",
        "items": [
          "Air Taxi",
          "Specialized Aviation"
        ]
      },
      {
        "name": "Airport Services",
        "items": [
          "Airline Catering",
          "Airport Operators",
          "Duty Free Shops"
        ]
      },
      {
        "name": "Freight & Logistics",
        "items": [
          "Air Logistics",
          "Cash Logistics",
          "Courier Shops",
          "Freight Forwarder",
          "Ground Logistics",
          "Integrated Logistics Operators",
          "Last Mile Delivery",
          "Marine Logistics",
          "Moving Companies",
          "Truck Rental",
          "Trucking",
          "Warehousing"
        ]
      },
      {
        "name": "Highways and Rail Operators",
        "items": [
          "Highway Operators",
          "Parking Lot Operators"
        ]
      },
      {
        "name": "Marine Port Services",
        "items": [
          "Marine Cargo Handling",
          "Port Operators",
          "Port Warehousing"
        ]
      },
      {
        "name": "Transportation",
        "items": [
          "Charter Bus",
          "Marine Passenger Transport",
          "Taxi",
          "Vehicle Rental"
        ]
      }
    ]
  },  
  {
    "category": "Media",
    "subcategories": [
      {
        "name": "Advertising and Marketing",
        "items": [
          "Advertising Agencies",
          "Branding and Design",
          "Digital Marketing",
          "Event Management",
          "Guerrilla Marketing",
          "Market Research",
          "Marketing Consulting",
          "Media Buying Agencies",
          "Outdoor Advertising",
          "PR Agencies",
          "Sales Agencies",
          "Sign Makers"
        ]
      },
      {
        "name": "Broadcasting",
        "items": [
          "Cable Service",
          "Radio Stations",
          "TV Stations"
        ]
      },
      {
        "name": "Entertainment Production",
        "items": [
          "Concert Production",
          "Entertainment Technical Services",
          "Film Production",
          "Music Production",
          "Photography",
          "Sports Franchises",
          "TV Production"
        ]
      },
      {
        "name": "Printing",
        "items": [
          "Book Printing",
          "Photocopying",
          "Screen Printing",
          "Typesetting"
        ]
      },
      {
        "name": "Professional Information",
        "items": [
          "Business Publishing",
          "Financial Information",
          "Legal Information",
          "News Agencies",
          "Rating Agencies",
          "Research Journals",
          "Risk & Compliance"
        ]
      },
      {
        "name": "Publishing",
        "items": [
          "Book Publishing",
          "Digital Publishing",
          "Directory Publishing",
          "Magazine Publishing",
          "Newspaper Publishing"
        ]
      }
    ]
  },
  {
    "category": "Retail Shops",
    "subcategories": [
      {
        "name": "Apparel Stores",
        "items": [
          "Baby Stores",
          "Bag Retailers",
          "Footwear Stores",
          "Jewelry Stores",
          "Luxury Apparel Retailers",
          "Men's Apparel Stores",
          "Sportswear Shops",
          "Teen Fashion Retailers",
          "Watch Stores",
          "Women's Apparel Stores"
        ]
      },
      {
        "name": "Auto Dealers",
        "items": [
          "Auto Accessories Shops",
          "Auto Repair and Service",
          "Bicycle Shops",
          "Boat Dealers",
          "Car Dealers",
          "Car Washes",
          "Marine Shops",
          "Motorcycle Dealers",
          "Tire Dealers",
          "Used Car Dealers"
        ]
      },
      {
        "name": "Computer Shops",
        "items": [
          "Electronics Stores",
          "Household Electronics Repair",
          "IT Retail",
          "Mobile Shops"
        ]
      },
      {
        "name": "Food & Drug Retail",
        "items": [
          "Food Markets",
          "Food Wholesale",
          "Grocery Shops",
          "Health Food Stores",
          "Liquor Stores",
          "Meat Shops",
          "Pharmacies",
          "Supermarkets",
          "Tobacco Shops",
          "Vending Machines"
        ]
      },
      {
        "name": "Home Furnishing Shops",
        "items": [
          "Art Galleries",
          "Bathroom Fitting Shops",
          "Electrical Supplies Stores",
          "Furniture Stores",
          "Garden Nurseries",
          "Hardware Stores",
          "Luxury Furnishing Retailers",
          "Paint Stores",
          "Soft Furnishing Stores"
        ]
      },
      {
        "name": "Specialty Retailers",
        "items": [
          "Battery Stores",
          "CD Shops",
          "Craft Stores",
          "Florists",
          "Funeral Services",
          "Gifting",
          "Military Stores",
          "Movie & Book Rental",
          "Musical Instrument Retailers",
          "Optical Stores",
          "Pet Shops",
          "Sports Goods Stores",
          "Toy Shops",
          "Used Merchandise Stores"
        ]
      }
    ]
  },
  {
    "category": "Technology",
    "subcategories": [
      {
        "name": "Computer Hardware",
        "items": [
          "Computer Hardware Component Assembly",
          "Computer Peripherals",
          "Home Printers",
          "Laptops and Desktops",
          "Servers & Systems",
          "Storage Devices",
          "Tablet Computers"
        ]
      },
      {
        "name": "Electronic Equipment",
        "items": [
          "Biometric Products",
          "Display Screens",
          "Drones",
          "Electronics Manufacturing",
          "Robot Manufacturing"
        ]
      },
      {
        "name": "Household Electronics",
        "items": [
          "Consumer Electronics",
          "Home Appliances",
          "Home Audio",
          "Kitchen Appliances",
          "Luxury Appliances",
          "Photographic Equipment",
          "TV Manufacturing"
        ]
      },
      {
        "name": "Internet",
        "items": [
          "Crypto",
          "Ecommerce Websites",
          "Edutech",
          "FinTech",
          "Gaming Websites",
          "Healthcare Portal",
          "Job Portals",
          "Mobile Apps",
          "Online Marketplace",
          "Search Engine Websites",
          "Social Network Websites",
          "Travel Portals"
        ]
      },
      {
        "name": "Networking Equipment",
        "items": [
          "Broadcast Equipment",
          "Conferencing Equipment",
          "Fiber Optic Cables",
          "Network Equipment",
          "Satellite Equipment",
          "Surveillance Devices"
        ]
      },
      {
        "name": "Office Equipment",
        "items": [
          "Equipment & Supplies Rental",
          "Office Supplies Wholesale",
          "POS Terminal",
          "Printers",
          "Scientific Equipment",
          "Stationery"
        ]
      },
      {
        "name": "Phones and Handheld Devices",
        "items": [
          "GPS Devices",
          "Mobile Device Component Assembly",
          "Mobile Phones",
          "Personal Music Players",
          "Phone Accessories"
        ]
      },
      {
        "name": "Semiconductor Equipment",
        "items": [
          "Semiconductor Equipment Wholesalers"
        ]
      },
      {
        "name": "Semiconductors",
        "items": [
          "IC Fabrication",
          "RFID Systems",
          "Semiconductor Wholesale"
        ]
      },
      {
        "name": "Software Companies",
        "items": [
          "Analytics Software",
          "Application Software",
          "Cloud Software",
          "Database Software",
          "Enterprise Software",
          "Geospatial Technology",
          "Internet of Things",
          "Medical Software",
          "Programming Software",
          "System Software",
          "Virtual & Augmented Reality",
          "Web Hosting"
        ]
      },
      {
        "name": "Telecommunications",
        "items": [
          "ISPs",
          "Satellite Broadband",
          "Telecom Carriers",
          "Telecom Infrastructure",
          "Telecom Resellers",
          "VOIP Services"
        ]
      }
    ]
  },
  {
    "category": "Textiles",
    "subcategories": [
      {
        "name": "Apparel and Accessories",
        "items": [
          "Accessories",
          "Apparel Wholesale",
          "Bags Manufacturing",
          "Children Clothing",
          "Fashion Eyewear",
          "Hosiery",
          "Industrial Clothing",
          "Jeans Manufacturing",
          "Jewellery",
          "Knitwear",
          "Laundry Business",
          "Lingerie",
          "Luxury Accessories",
          "Luxury Clothing",
          "Men's Clothing",
          "Pet Clothing",
          "Sportswear",
          "Tailoring",
          "Theatrical Costumes",
          "Watches",
          "Women's Clothing"
        ]
      },
      {
        "name": "Footwear",
        "items": [
          "Children Footwear",
          "Footwear Wholesale",
          "Functional Footwear",
          "Luxury Footwear",
          "Men's Footwear"
        ]
      },
    ]
  },
  {
    "category": "Travel & Leisure",
    "subcategories": [
      {
        "name": "Casinos and Gaming",
        "items": [
          "Casino Machine Manufacturing",
          "Casinos",
          "Gaming Machine Operators",
          "Lottery Operators",
          "Race Tracks"
        ]
      },
      {
        "name": "Hotels and Resorts",
        "items": [
          "Banquet Halls",
          "Bed & Breakfasts",
          "Campgrounds",
          "Campsite Operators",
          "Cruise Lines",
          "Guest Houses",
          "Hotel Management",
          "Hotels",
          "Luxury Hotels",
          "Resorts",
          "Serviced Apartments",
          "Timeshares",
          "Wellness Retreats"
        ]
      },
      {
        "name": "Leisure and Recreation",
        "items": [
          "Adult Entertainment",
          "Amusement Parks",
          "Bowling Alleys",
          "Entertainment Centers",
          "Golf Courses",
          "Hot Air Balloons",
          "Motorsports",
          "Movie Theaters",
          "Museums",
          "Pet Care",
          "Snooker Clubs",
          "Spiritual & Psychic Services",
          "Sports Facilities",
          "Tour Operators",
          "Travel Agencies",
          "Video Games Stores",
          "Zoos"
        ]
      },
      {
        "name": "Recreational Products",
        "items": [
          "Leisure Products Wholesale",
          "Luxury Recreational Products",
          "Musical Instruments",
          "Sport Goods",
          "Toys & Games"
        ]
      }
    ]
  },
   
];
